module.exports = __webpack_public_path__ + "fonts/Figtree-Italic-213144c.ttf";